module.exports = __webpack_public_path__ + "media/images/logo-21335ee5.svg";